module.exports = __webpack_public_path__ + "img/home-perfect-3.62a0d6c1.png";